import { SortDirection } from '@deltasierra/react-hooks';
import * as React from 'react';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import styled from 'styled-components';
import { DSTableCell } from '../DSTableCell';
import { DSGrid } from '../../Grid';

const SortableTableHeaderCellContainer = styled(DSGrid).attrs({
    alignItems: 'center',
    container: true,
})`
    cursor: pointer;
`;

const SortArrowContainer = styled(DSGrid).attrs({
    alignContent: 'center',
    container: true,
    item: true,
    xs: 2,
})`
    height: 28px;
`;

const StyledUpArrowGridItem = styled(DSGrid).attrs({
    item: true,
})`
    color: #aeb7c7;
    height: 21px;
    position: relative;
    top: 8px;
`;

const StyledDownArrowGridItem = styled(DSGrid).attrs({
    item: true,
})`
    bottom: 8px;
    color: #aeb7c7;
    height: 21px;
    position: relative;
`;

export type SortableTableHeaderCellProps = {
    direction: SortDirection;
    label: string;
    width?: number | string;
    height?: number | string;
    dataCy?: string;
    onClick: () => void;
};

/**
 * Material UI table cell for headers in sortable table columns.
 *
 * @param param0 - SortableTableHeaderCellProps
 * @param param0.direction - Direction of sort arrow
 * @param param0.label - Header label
 * @param param0.onClick - On header click
 * @param param0.dataCy - Cypress test ID
 * @param param0.width - Width of header cell
 * @param param0.height - Height of header cell
 * @returns JSX.Element
 */
export function SortableTableHeaderCell({
    dataCy,
    direction,
    height,
    label,
    onClick,
    width,
}: SortableTableHeaderCellProps): JSX.Element {
    return (
        <DSTableCell data-cy={dataCy} height={height} width={width}>
            <SortableTableHeaderCellContainer onClick={onClick}>
                <DSGrid item>{label}</DSGrid>
                <SortArrowContainer>
                    {!direction && (
                        <DSGrid container data-testid="sortable-table-header-cell-unsorted-icon" direction="column">
                            <StyledUpArrowGridItem>
                                <ArrowDropUp />
                            </StyledUpArrowGridItem>
                            <StyledDownArrowGridItem>
                                <ArrowDropDown />
                            </StyledDownArrowGridItem>
                        </DSGrid>
                    )}
                    {direction === 'asc' && (
                        <ArrowDropUp color="primary" data-testid="sortable-table-header-cell-sorted-asc-icon" />
                    )}
                    {direction === 'desc' && (
                        <ArrowDropDown color="primary" data-testid="sortable-table-header-cell-sorted-desc-icon" />
                    )}
                </SortArrowContainer>
            </SortableTableHeaderCellContainer>
        </DSTableCell>
    );
}

SortableTableHeaderCell.displayName = 'SortableTableHeaderCell';
